export const routes = [
  {
    name: 'protocolItem_list',
    path: '/protocolItem',
    componentConfig: [
      {
        component: 'EndpointListContainer',
        props: {
          endpoint: 'protocolItem',
          slice: 'protocolItem/protocolItem/list',
          selectAction: {
            preview: {
              meta: {
                modal: {
                  body: [
                    {
                      component: 'ProtocolItemDetailContainer'
                    }
                  ]
                }
              }
            },
            edit: {
              type: 'protocolItem/protocolItem/edit/start',
              meta: {
                modal: {
                  title: 'protocolItem.actions.update',
                  body: [
                    {
                      component: 'ProtocolItemEditForm'
                    }
                  ]
                }
              }
            }
          }
        },
        children: [
          {
            component: 'Grid',
            props: {
              title: 'protocolItem.module.name',
              config: {
                columns: {
                  id: {
                    label: 'protocolItem.entity.id'
                  },
                  protocol: {
                    label: 'protocolItem.entity.protocol',
                    display: {
                      type: 'objectProps',
                      props: ['id']
                    }
                  },
                  contractItem: {
                    label: 'protocolItem.entity.contractItem',
                    display: {
                      type: 'objectProps',
                      props: ['description']
                    }
                  },
                  donePercent: {
                    label: 'protocolItem.entity.donePercent'
                  },
                  cost: {
                    label: 'protocolItem.entity.cost'
                  },
                  updatedAt: {
                    label: 'protocolItem.entity.updatedAt',
                    display: {
                      type: 'datetime'
                    }
                  }
                },
                filtersConfig: [],
                actions: [
                  {
                    label: 'protocolItem.actions.create',
                    type: 'create',
                    icon: 'plus',
                    action: {
                      type: 'protocolItem/protocolItem/edit/start',
                      meta: {
                        modal: {
                          title: 'protocolItem.create',
                          body: [
                            {
                              component: 'ProtocolItemCreateForm'
                            }
                          ]
                        }
                      }
                    }
                  }
                ],
                recordActions: [
                  {
                    label: '',
                    type: 'edit',
                    icon: 'pen',
                    action: {
                      type: 'protocolItem/protocolItem/edit/start',
                      meta: {
                        modal: {
                          title: 'protocolItem.update',
                          body: [
                            {
                              component: 'ProtocolItemEditForm'
                            }
                          ]
                        }
                      }
                    }
                  },
                  {
                    label: '',
                    type: 'delete',
                    icon: 'trash',
                    action: {
                      type: 'protocolItem/protocolItem/list/delete',
                      meta: {
                        API: {
                          endpoint: 'protocolItem',
                          operation: 'delete'
                        },
                        confirm: {
                          props: {
                            title: 'ims.confirm.delete.title',
                            message: 'ims.confirm.delete.message',
                            confirmText: 'ims.confirm.delete.confirmText',
                            cancelText: 'ims.confirm.delete.cancelText'
                          },
                          confirmed: false
                        }
                      }
                    }
                  }
                ]
              }
            }
          }
        ]
      }
    ],
    exact: true,
    section: false,
    module: 'protocolItem',
    label: 'protocolItem.module.name',
    icon: null
  }
];
